import { Sidecar } from '@eppendorf/vnls-react-components';
import { type ReactElement, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { LoadingErrorHint } from '$components/loading-error-hint/loading-error-hint';
import { SidecarRouterOutlet } from '$components/sidecar-router/sidecar-router-outlet';
import { useGetStabilityReport } from '$features/report-hub/report-hub.api';
import { StabilityReportSidecarHeader } from '$features/report-hub/stability-report/stability-report-sidecar-header';

import './stability-report-sidecar.scss';

export function StabilityReportSidecar(): ReactElement {
  const [searchParams, setSearchParams] = useSearchParams();
  const [isSidecarOpen, setIsSidecarOpen] = useState(true);

  const reportId = searchParams.get('id');
  const { isError, data: report } = useGetStabilityReport(reportId);

  const handleSidecarOpenChange = () => {
    setIsSidecarOpen(false);
    setSearchParams(
      (prev) => {
        prev.delete('sidecarRoute');
        prev.delete('id');
        return prev;
      },
      { replace: true },
    );
  };

  return (
    <Sidecar isOpen={isSidecarOpen} onOpenChange={handleSidecarOpenChange}>
      {(isError || !report) && <LoadingErrorHint className="m-top-xl" />}

      {report && (
        <div className="flex flex__dir--column flex__ai--stretch h-full">
          <StabilityReportSidecarHeader report={report} />
          <div className="sidecar__details box box-remove-padding">
            <div className="sidecar__outlet-wrapper">
              <SidecarRouterOutlet />
            </div>
          </div>
        </div>
      )}
    </Sidecar>
  );
}
